import type { ReactNode } from "react";
import React from "react";
import { isUserProfileAvailable } from "../Shared";

type OwnProps = {
    children: ReactNode;
};

/**
 * Suspending (React Suspense) mounting of children until profile is available
 */
export const ProfileSuspender = (props: OwnProps) => {
    if (!isUserProfileAvailable()) {
        // eslint-disable-next-line
        throw new Promise((resolve) => {
            let retries = 0;
            const checker = () =>
                setTimeout(() => {
                    retries++;
                    if (isUserProfileAvailable()) {
                        resolve();
                    } else if (retries <= 100) {
                        checker();
                    }
                }, 200);
            checker();
        });
    }
    return <>{props.children}</>;
};
